// This entire file was made by Claude.
// It's completely redundant, because we should rewrite the mindmap-orgchart-element
// to work with the data as is provided by the backend.
// Then there's no need to transform the data.
import { indexBy } from "rambda";
import { OrgChartItem } from "frontend/hooks/use-board-integrations.types";

interface Configuration {
  columnMapping: {
    jobTitle: string;
    parentId: string;
    selfId: string;
  };
}

export class OrgChartColumns {
  private readonly columnsObject: { [key: string]: any };
  private readonly emailColumnId: any;
  private readonly selfId: string;
  private readonly parentId: string;
  private readonly jobTitle: string;

  constructor(readonly configuration: Configuration, columns: any[]) {
    const { selfId, parentId, jobTitle } = configuration.columnMapping;
    this.selfId = selfId;
    this.parentId = parentId;
    this.jobTitle = jobTitle;
    this.columnsObject = indexBy("id", columns);
    this.emailColumnId = columns.find((col) => /email/i.test(col.name))?.id;
  }

  isWellKnownColumn(columnId: string) {
    return (
      columnId == this.selfId ||
      columnId == this.parentId ||
      columnId == this.jobTitle ||
      columnId == this.emailColumnId ||
      this.columnsObject[columnId].type == "subitems"
    );
  }

  getJobTitle(item: any) {
    return this.get(item, this.jobTitle);
  }
  getParent(item: any) {
    return this.get(item, this.parentId);
  }

  getName(item: any) {
    return this.get(item, this.selfId);
  }

  getEmail(item: any) {
    if (!this.emailColumnId) {
      return "";
    }
    return this.get(item, this.emailColumnId);
  }

  get(item: any, columnId: string) {
    return this.internalGet(item, columnId) || "";
  }

  public getColor(item: any, columnId: string) {
    try {
      return this.columnsObject[columnId].settings.labels_colors[item.columnValues[columnId].value.index].color;
    } catch {
      return undefined;
    }
  }

  private internalGet(item: any, columnId: string) {
    if (columnId == "name") {
      return item.name;
    }
    if (!(columnId in this.columnsObject)) {
      // This should be considered an error.
      console.log("columnId not in columnsObject", columnId);
      return "";
    }

    try {
      const value = item.columnValues[columnId];
      switch (this.columnsObject[columnId].type) {
        case "email":
          return value?.value?.text ?? "";
        default:
          if (value === null) {
            return "";
          }
          if (typeof value === "object") {
            return value.text ?? "";
          }
          return value;
      }
    } catch {
      return "";
    }

    // This code assumes backend asks for column_values_str and we have to decode the result.
    // It used to work (really good) until monday api changed (I hope it will come back)
    // try {
    //   // Always remember: items can have no data for a column.
    //   switch (this.columnsObject[columnId].type) {
    //     case "status":
    //       return this.columnsObject[columnId].settings.labels[item.columnValues[columnId]?.index || 0];
    //     case "people": {
    //       // backend fetched data for us. it's either list of names, or a single string
    //       const value = item.columnValues[columnId];
    //       return Array.isArray(value) ? value.join(", ") : value;
    //     }
    //     case "phone":
    //       return item.columnValues[columnId]?.phone;
    //     case "date":
    //       return item.columnValues[columnId]?.date;
    //     case "dropdown": {
    //       const labels = this.columnsObject[columnId].settings.labels;
    //       return item.columnValues[columnId].ids
    //         .map((id: number) => labels.find(propEq(id, "id"))?.name ?? "")
    //         .join(", ");
    //     }
    //     case "tags": {
    //       // backend gets tags for us (for now)
    //       return item.columnValues[columnId];
    //     }
    //     case "timeline": {
    //       const { from, to } = item.columnValues[columnId];
    //       return `${from} - ${to}`;
    //     }
    //     default: {
    //       const value = item.columnValues[columnId];
    //       if (value === null) {
    //         return "";
    //       }
    //       if (typeof value === "object") {
    //         return value.text ?? "";
    //       }
    //       return value;
    //     }
    //   }
    // } catch {
    //   return "";
    // }
  }
}

export function convertData(items: any[], configuration: Configuration, columns: any[]): OrgChartItem[] {
  const columnDataGetter = new OrgChartColumns(configuration, columns);

  return items.map((item) => {
    return {
      id: item.id,
      self: columnDataGetter.getName(item),
      name: columnDataGetter.getName(item),
      parent: columnDataGetter.getParent(item),
      job_title: columnDataGetter.getJobTitle(item),
      email: columnDataGetter.getEmail(item),
      columns,
      columnValues: item.columnValues,
    };
  });
}
